// LLM generated - Model Codex 5.3
import { useRouter } from 'next/router';
import { useCallback, useContext, useEffect, useLayoutEffect, useMemo, useState } from 'react';

import { Routes } from '~/domains/common/constants/routes';
import { PrevLocationContext } from '~/domains/common/context/PrevLocationContext';

import BoardSearchPanel from './BoardSearchPanel';

export function QuickPicksBoardSearchHeader() {
  const router = useRouter();
  const { prevAsPath } = useContext(PrevLocationContext);
  const [backFromPrev, setBackFromPrev] = useState<string | null>(null);

  const searchValue = (router.query.search as string) ?? '';

  useLayoutEffect(() => {
    setBackFromPrev((current) => {
      if (current !== null) return current;
      if (prevAsPath && !prevAsPath.startsWith('/quick-picks/board/search')) return prevAsPath;
      return current;
    });
  }, [prevAsPath]);

  const fallbackBoardHref = useMemo(() => {
    const query = { ...router.query };
    delete query.search;

    const league = query.league;

    if (league === 'popular') {
      // eslint-disable-next-line local-rules/no-cast-to-never
      return Routes.quickPicksPopular(query as never);
    }

    // eslint-disable-next-line local-rules/no-cast-to-never
    return Routes.quickPicksBoard(query as never);
  }, [router.query]);

  const closeHref = backFromPrev ?? fallbackBoardHref;

  const handleSearchChange = useCallback(
    (value: string) => {
      const nextQuery = { ...router.query };

      if (value) {
        nextQuery.search = value;
      } else {
        delete nextQuery.search;
      }

      router.push(
        {
          pathname: router.pathname,
          query: nextQuery,
        },
        undefined,
        { shallow: true }
      );
    },
    [router]
  );

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        router.push(closeHref);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [closeHref, router]);

  return (
    <BoardSearchPanel
      value={searchValue}
      onChange={handleSearchChange}
      closeHref={closeHref}
      isFixed
    />
  );
}
